<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField
      :form="formInline"
      :formCtrl="formCtrl"
      @onSearch="onSearch"
      @onReset="onReset"
      @onChange="onSearchItemChange"
    >
      <template #end>
        <el-form-item>
          <el-button type="primary" @click="goPaymentRecord">打款记录</el-button>
        </el-form-item>

        <!-- 导出按钮 -->
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`预支款列表`)"
            >导出</el-button
          >
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="BatchPay">批量打款</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table
      ref="table"
      :tableData="tableData"
      :cols="cols"
      :page="page"
      :limit="limit"
      :total="total"
      :showSelect="true"
      :showIndex="true"
      :showTotal="true"
      :getTotal="getTotal"
      :btns="btns"
      @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"
    >
    </Table>

    <FormDialog
      ref="dialog"
      :title="title"
      :width="'570px'"
      :labelWidth="'110px'"
      :form="mform"
      :rules="mrules"
      :formCtrl="mformCtrl"
      :viewMode="viewMode"
      @onChange="onModalChange"
      @onModalSubmit="onModalSubmit"
    ></FormDialog>

    <Dialog class="dialog" ref="carDialog" :title="title2" @closed="onClose">
      <template #default>
        <div class="typebox">
          <div class="label">打款类型：</div>

          <el-checkbox-group
            class="typelist"
            v-model="typeCheckedList"
            @change="onTypeCheckChange"
          >
            <el-checkbox
              class="item"
              v-for="(c, i) in typelist"
              :key="'item' + i"
              :label="c.value"
            >
              <div class="row0">{{ c.label }}</div>
            </el-checkbox>
          </el-checkbox-group>
        </div>

        <el-scrollbar class="content">
          <CarList
            ref="carlist"
            :list="selection"
            :checkedIds="checkedIds"
            @onCheckChange="onCheckChange"
          />
        </el-scrollbar>

        <div class="btns">
          <el-button type="primary" @click="onModal2Submit">确 认</el-button>
          <el-button @click="onModalCancel">取 消</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceInitialPayment",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "car",
      breadcrumb: [
        { name: "财务管理", path: `/finance/initialPayment` },
        { name: "预支款管理", path: `/finance/initialPayment` },
      ],
      formInline: {},
      formCtrl: [
        {
          label: "车队长",
          keyName: "fleet",
          type: "select",
          options: [],
        },
        {
          label: "车种",
          keyName: "car_type_id",
          type: "select",
          options: [],
        },
        {
          label: "预支款类型",
          keyName: "prepaid_type_id",
          type: "select",
          options: [],
        },
        {
          ...this.ctrls.license,
        },
        {
          label: "预支款最低值",
          keyName: "settled",
          placeholder: "请填写金额",
          type: "number",
        },
      ],
      cols: [
        { prop: "license", label: "车牌号", minwidth: 100 },
        { prop: "driver", label: "司机" },
        { prop: "carstatus", label: "车辆状态" },
        { prop: "money", label: "预支款余额" },
        { prop: "commission", label: "司机提成" },
        { prop: "travel_expenses", label: "差旅费" },
        { prop: "other", label: "其他费用" },
        { prop: "paytime", label: "最近打款时间", minwidth: 125 },
        { prop: "vtype", label: "车种" },
        { prop: "prepaid_type", label: "预支款类型" },
        { prop: "bank_name", label: "开户银行" },
        { prop: "cardholder", label: "持卡人" },
        { prop: "bank_card_no", label: "银行账号", minwidth: 130 },
      ],
      getTotalProperty: ["money", "commission", "travel_expenses", "other"],
      btns: [
        {
          //...this.viewBtn,
          title: "打款记录",
          img: require("@/assets/img/shipper_order_list.png"),
          unimg: require("@/assets/img/shipper_order_list_hover.png"),
          cb: ({ id, license }) => {
            this.$router.push(
              `/finance/initialPaymentRecord?id=${id}&license=${license}`
            );
          },
        },
        {
          //...this.editBtn,
          title: "打款",
          img: require("@/assets/img/initialPayment_01.png"),
          unimg: require("@/assets/img/initialPayment_01_hover.png"),
          cb: (a) => {
            this.curData = a;
            const { id, license, money } = a;
            // console.log(id, license, money)
            this.mform = {
              ...this.mform,
              id,
              license,
              money,
              paymoney: undefined,
              photo: undefined,
            };
            this.$forceUpdate();
            this.showDialog();
            // console.log({ ...this.mform })
          },
        },
      ],
      curData: {},
      title: "添加打款记录",
      viewMode: false,
      mform: {
        paymoney: undefined,
        // photo: undefined,
      },
      mrules: {
        paymoney: [
          {
            required: true,
            message: "请填写打款金额",
            trigger: "blur",
          },
        ],
        // photo: [
        //   {
        //     required: true,
        //     message: '请上传打款凭证',
        //     trigger: 'blur',
        //   }
        // ],
      },
      mformCtrl: [
        {
          ...this.ctrls.license,
          label: "车牌号",
          disabled: true,
        },
        {
          label: "余款",
          keyName: "money",
          err: "请填写余款",
          type: "number",
          disabled: true,
        },
        {
          label: "打款类型",
          keyName: "type",
          type: "select",
          options: [
            { label: "全部", value: "money" },
            { label: "司机提成", value: "commission" },
            { label: "差旅费", value: "travel_expenses" },
            { label: "其他费用", value: "other" },
          ],
          disabled: false,
        },
        {
          label: "打款金额",
          keyName: "paymoney",
          err: "请填写打款金额",
          type: "number",
          disabled: false,
        },
        {
          label: "打款凭证",
          keyName: "photo",
          tips: "最多上传2张图片",
          type: "file",
          max: 2,
          disabled: false,
        },
        {
          label: "备注",
          keyName: "remark",
          err: "请填写备注信息",
          type: "textarea",
          rows: 3,
          disabled: false,
        },
      ],
      getListUrl: "moneyrec",
      nosetpage: 1,
      // 车辆列表弹窗
      title2: "打款列表",
      checkedIds: [],
      checkedLists: [],

      typeCheckedList: [],
      typelist: [
        // { label: '全部', value: 'money' },
        { label: "司机提成", value: "commission" },
        { label: "差旅费", value: "travel_expenses" },
        { label: "其他费用", value: "other" },
      ],

      mformCtrl2: [
        {
          label: "打款类型",
          keyName: "type",
          type: "check",
          options: [
            // { label: '全部', value: 'money' },
            { label: "司机提成", value: "commission" },
            { label: "差旅费", value: "travel_expenses" },
            { label: "其他费用", value: "other" },
          ],
          disabled: false,
        },
      ],
    };
  },
  methods: {
    onCheckChange(v) {
      // console.log(v)
      // console.log([...this.checkedIds])
      if (v && v.length) {
        this.checkedIds = [...v];
      }
      // console.log([...this.checkedIds])
    },

    BatchPay() {
      if (!this.selection.length) {
        this.$message({
          type: "warning",
          message: "请选择车辆!",
        });
        return;
      }
      console.log([...this.selection]);
      this.selection.map((v) => {
        this.checkedIds.push(v.id);
      });
      this.showDialog("carDialog");
    },
    onClose() {
      this.selection = [];
      this.typeCheckedList = [];
      // console.log(this.typeCheckedList);
      this.checkedIds = [];
      // console.log(this.checkedIds);

      if (this.$refs["carlist"] && this.$refs["carlist"].clearChecked) {
        this.$refs["carlist"].clearChecked();
      }

      if (this.$refs["table"] && this.$refs["table"].clearSelection) {
        this.$refs["table"].clearSelection();
      }
    },
    onModal2Submit() {
      if (!this.typeCheckedList.length) {
        this.$message({
          type: "warning",
          message: "请选择打款类型!",
        });
        return;
      }
      this.checkedLists = [];
      this.selection.map((c) => {
        if (this.checkedIds.includes(c.id)) {
          this.checkedLists.push(c);
        }
      });
      // console.log(this.checkedLists)
      // console.log(this.checkedIds)

      let url = `car/addmoney`;
      const params = {
        userid: this.user.id,
        cid: this.checkedIds,
        type: this.typeCheckedList || "money",
      };

      this.loading = true;
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg === "success") {
            this.$message({
              type: "success",
              message: "提交成功!",
            });
            this.loading = false;
            this.hideDialog();
            this.getList();
          } else {
            this.loading = false;
            this.$message({
              type: "error",
              message: msg,
            });
          }
        },
        (err) => {
          this.loading = false;
          console.log(err);
          this.$message({
            type: "error",
            message: "提交数据失败，请稍后重试！",
          });
        }
      );

      this.hideDialog("carDialog");
    },
    onModalCancel() {
      this.hideDialog("carDialog");
    },

    dataObjHandler(v) {
      return v;
    },
    goPaymentRecord() {
      this.$router.push(`/finance/initialAllPaymentRecord`);
    },
    onModalChange({ key, value }) {
      if (key === "type") {
        // 打款类型选择‘全部’，打款金额直接取余额的负值，并禁止编辑
        this.mformCtrl.map((v) => {
          if (v.keyName === "paymoney") {
            if (value === "money") {
              v.disabled = true;
              // this.$set(this.mform, v.keyName, Math.abs(this.curData['money']))
              this.$set(this.mform, v.keyName, -this.curData["money"]);
              // console.log({ ...this.curData })
            } else {
              v.disabled = false;
              this.$set(this.mform, v.keyName, null);
            }
          }
        });
      }
      // console.log({ ...this.mformCtrl })
      console.log({ ...this.mform });
    },
    onModalSubmit() {
      const path = this.$route.path;
      this.setState({
        key: "scrollTop" + path,
        value: this.$refs.table.scrollTop,
      });
      // console.log({ ...this.mform });
      const { id, paymoney, type, photo, remark } = this.mform;

      if (!paymoney) {
        this.$message({
          type: "warning",
          message: "请填写打款金额！",
        });
      }
      if (!type) {
        this.$message({
          type: "warning",
          message: "请选择打款类型！",
        });
      }
      let url = `car/addmoney`;
      const params = {
        userid: this.user.id,
        cid: id,
        type,
        paymoney,
        remark,
      };
      if (photo) {
        params["photo"] = photo.map((v) => {
          let result = v;
          if (v.response && v.response.photo) {
            result = { url: v.response.photo };
          }
          return result;
        });
      }

      this.loading = true;
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg === "success") {
            this.$message({
              type: "success",
              message: "提交成功!",
            });
            this.hideDialog();
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "提交数据失败，请稍后重试！",
          });
        }
      );
    },
    // setFleet({ team }) {
    //   this.formCtrl.map((c) => {
    //     if (c.keyName == "fleet") {
    //       c.options = team.map((v) => {
    //         return {
    //           label: v.nickname,
    //           value: v.id,
    //         };
    //       });
    //     }
    //   });
    //   this.$forceUpdate();
    // },
    onSearchItemChange({ key, value }) {
      // console.log(key, value);
      if (["starttime", "edittime", "fleet", "month"].includes(key)) {
        this.getList();
      } else if (key == "car_type_id") {
        console.log(key, value);
        this.getPrepaidType(value);
      }
    },
    getPrepaidType(value) {
      let url = `car/getprepaidtype`;
      const params = {
        car_type_id: value,
      };
      this.post(
        url,
        params,
        ({ msg, prepaid_type }) => {
          if (msg) {
            this.formCtrl.map((c) => {
              if (c.keyName == "prepaid_type_id" && prepaid_type && prepaid_type.length) {
                c.options = prepaid_type.map((v) => {
                  return {
                    label: v.name,
                    value: v.id,
                  };
                });
              }
            });
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getOption() {
      let url = `car/daypayoption`;
      const params = {
        userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ msg, fleet, car_type }) => {
          if (msg) {
            // console.log(fleet, prepaid_type)
            this.formCtrl.map((c) => {
              if (c.keyName == "fleet" && fleet && fleet.length) {
                c.options = fleet.map((v) => {
                  return {
                    label: v.nickname,
                    value: v.id,
                  };
                });
              }
              if (c.keyName == "car_type_id" && car_type && car_type.length) {
                c.options = car_type.map((v) => {
                  return {
                    label: v.name,
                    value: v.id,
                  };
                });
              }
            });
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "删除失败，请稍后重试！",
          });
        }
      );
    },

    onTypeCheckChange(v) {
      console.log(v);
      this.typeCheckedList = v;
    },
  },
  mounted() {
    this.getOption();
    const { user_group_id } = this.user;
    if ([5].includes(user_group_id)) {
      this.btns.length = 1;
    }
    // console.log("formInline", { ...this.formInline });
    const { car_type_id } = this.formInline;
    if (car_type_id) {
      this.getPrepaidType(car_type_id);
    }
  },
};
</script>

<style lang="less" scoped>
.dialog {
  .el-form {
    padding-right: 50px;
  }

  .btns {
    margin-left: 110px;
  }
}

.dialog {
  /deep/ .el-dialog {
    width: 931px;
  }

  .content {
    height: 500px;

    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    /deep/ .is-horizontal {
      display: none;
    }
  }

  .tit {
    line-height: 20px;
    font-size: 15px;
    font-weight: bold;
    color: #303133;
    padding-left: 16px;
    position: relative;
    margin: 0 auto 16px;

    &::before {
      position: absolute;
      left: 0;
      top: 5px;
      content: "";
      width: 10px;
      height: 10px;
      background: #67c23a;
      border-radius: 50%;
    }

    &.tit2 {
      &::before {
        background: #f56c6c;
      }
    }
  }

  .btns {
    text-align: center;
    margin-left: 0;
  }
}

/deep/ .el-dialog .btns .mians {
  text-align: center;
}

.typebox {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .label {
    margin-right: 10px;
    margin-top: -1px;
  }
}
</style>
